<!--  FINANCE SKIP  -->

<div class="written-content padded">
	<h3>Are you sure you want to skip applying for finance?</h3>
	<p>
		Please note that you can complete your finance application and adjust this order yourself at anytime by
		following the link within the e-mail/SMS that we've sent to you.
	</p>
	<p>
		Alternatively you can contact us and we'll be happy to help.
	</p>
</div>

<!--  END FINANCE SKIP  -->
